import { render, staticRenderFns } from "./IconDemo.vue?vue&type=template&id=2c59256a&scoped=true&"
import script from "./IconDemo.vue?vue&type=script&lang=js&"
export * from "./IconDemo.vue?vue&type=script&lang=js&"
import style0 from "./IconDemo.vue?vue&type=style&index=0&id=2c59256a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c59256a",
  null
  
)

export default component.exports